export default "__VITE_ASSET__CClSCZLZ__"